// @flow

import axios from 'axios';
import { getBaseUrl } from '../config/config';

export default function getConstraintDetail(projectId: string, constraintId: number): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/constraints/${constraintId}`);
}
